@if (alertService.data) {
<div
	class="content-alert fullscreen vertical-align"
	[@openClose]="alertService.data && alertService.data.show ? 'open' : 'closed'"
>
	<div class="content modal-content">
		<div class="modal-header custom-header">
			<h5 class="modal-title fs-18 fw-500 m-0">
				{{ alertService.data.title }}
			</h5>
			<button
				type="button"
				class="btn-close"
				[disabled]="alertService.data.loading"
				(click)="close(false)"
			></button>
		</div>
		<div class="modal-body p-2">
			@if (alertService.data.subtitle) {
			<div class="text-muted mb-2">
				{{ alertService.data.subtitle }}
			</div>
			} @if (alertService.data.showInput !== false) {
			<input
				class="form-control"
				[(ngModel)]="response.text"
				[disabled]="alertService.data.loading"
				type="text"
				placeholder="mail@example.com"
			/>
			} @if (alertService.data.checkbox) {
			<div class="form-check mt-3">
				<input
					class="form-check-input"
					type="checkbox"
					[(ngModel)]="response.checkValue"
					[disabled]="alertService.data.loading"
					id="alertCheck"
				/>
				<label class="form-check-label" for="alertCheck">
					{{ alertService.data.checkbox.title }}
				</label>
			</div>
			}
		</div>
		<div class="modal-footer custom-footer">
			<button class="btn btn-outline-primary mr-1" [disabled]="alertService.data.loading" (click)="close(false)">
				{{ alertService.data.cancelButtonText }}
			</button>
			<button
				class="btn btn-primary"
				[disabled]="(alertService.data.showInput !== false && !response.text) || alertService.data.loading"
				(click)="close(true)"
			>
				@if (!alertService.data.loading) {
				<span>{{ alertService.data.confirmButtonText }}</span>
				} @if (alertService.data.loading) {
				<span>
					<div class="spinner-loading-button spinner-border text-white" role="status"></div>
				</span>
				}
			</button>
		</div>
	</div>
</div>
}
